import { Component, h } from 'preact';
import { connect } from 'preact-redux';
import { MediaQuery } from '../media-query';

class PromoMessage extends Component {
    componentWillMount() {
        this.props.requirePromoMessage(this.props.placement);
        this.setState({
            shown: false,
            last_top: 0,
        });
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render({ message, placement }) {
        if (message) {
            return (
                <promo-message
                  dangerouslySetInnerHTML={{__html: message}}
                  onClick={this.trackClick}
                  placement={placement}
                  ref={(elem) => { this.promoMessage = elem; }}
                />
            );
        }

        return null;
    }

    trackClick = () => {
        const category = this.props.placement + ' promo message';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent([category, action, this.props.code]);
        this.props.trackPromo([category, this.props.code]);
    }

    handleScroll = () => {
        if (MediaQuery.isMobile() && this.props.placement == 'topbar' && typeof this.promoMessage != 'undefined') {
            const top = window.pageYOffset;

            if (top >= 315 && top > this.state.last_top) {
                this.promoMessage.classList.add('shown');
            } else if (top < this.state.last_top) {
                this.promoMessage.classList.remove('shown');
            }

            this.setState({last_top: top});
        }
    }
}

const mapStateToProps = (state, { placement }) => ({
    logged_in: state.user && state.user.logged_in,
    message: state['promo-message'] && state['promo-message'][placement] && state['promo-message'][placement].message,
    code: state['promo-message'] && state['promo-message'][placement] && state['promo-message'][placement].code,
});

const mapDispatchToProps = (dispatch) => ({
    requirePromoMessage: placement => dispatch({ type: 'promo-message:require', payload: placement }),
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoMessage);



// WEBPACK FOOTER //
// ./app/components/promo-message.js